import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";
import spriteImage from "../../assets/images/sprite.png";
import {useMediaQuery} from "react-responsive";

const Item = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 30px;
    margin-top: 20px;
    border: 1px solid #dedede;
    box-sizing: border-box;
    white-space: pre-wrap;
    
    ${device.pc} {
        flex-direction: column;
        justify-content: start;
        gap: 10px;
    }

    ${device.tablet} {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 26px;
        
    }

    ${device.mobile} {
        flex-direction: row;
        justify-content: space-between;
        padding: 15px;
        margin-top: 0;
        width: 100%;
        min-width: 320px;
        max-width: 400px;

        &:first-child {
            margin-top: 0;
        }
    }
`;
const Icon = styled.span`
    display: inline-block;
    width: 90px;
    height: 90px;
    flex-shrink: 0;
    
    &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        background: ${({ image, position }) => `url(${image}) no-repeat ${position}`};
        background-size: 418px 402px;
        background-position: ${({ position }) => position};
    }

    ${device.tablet} {
        &::after {
            background: url(${spriteImage}) no-repeat ${({ position }) => position};
            background-size: 418px 402px;
        }
    }

    ${device.mobile} {
        width: 60px; 
        height: 60px;
        margin-right: 10px;
        &::after {
            background: url(${spriteImage}) no-repeat ${({ position }) => position};
            background-size: 275px 265px;
        }
    }
`;
const Text = styled.p`
    width: 70%;
    color: #4a4a4a;
    font-size: 15px;
    line-height: 26px;
    letter-spacing: -0.5px;
    box-sizing: border-box;

    span {
        display: block;
        color: #ed8e0c;
    }

    ${device.pc} {
        width: 100%;
        text-align: center;
        font-size: 16px;
    }

    ${device.tablet} {
        font-size: 17px;
        width: 100%;
        line-height: 30px;
        padding-top: 20px;
        text-align: center;
        letter-spacing: -0.8px;
        span {
            font-size: 17px;
        }
    }

    ${device.mobile} {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        letter-spacing: -0.8px;
        span {
            letter-spacing: -0.8px;
            font-size: 12px;
        }
    }
`;

const InfoCard = ({item,image}) => {
    const isMobile = useMediaQuery({maxWidth: 600});
    const adjustPosition = (position) => {
        if (!isMobile) return position;

        const [x, y] = position.split(' ');
        const scale = 0.65;
        const parseValue = (v) => {
            if (v.includes('px')) {
                return `${parseFloat(v) * scale}px`;
            }
            return v;
        };

        return `${parseValue(x)} ${parseValue(y)}`;
    };

    return (
        <Item>
            <Icon position={adjustPosition(item.position)} image={image} />
            <Text >{item.text} {item.desc && <span>{item.desc}</span>}</Text>
        </Item>
    );
};

export default InfoCard;
